export const countryCodesEnum = {
  SINGAPORE: 'SG',
};
